// ステークホルダーだけが辿り着く表示上のステータス。DB のステータスには存在しない
export const STAKEHOLDER_ANSWERS_IMPORTED = "STAKEHOLDER_ANSWERS_IMPORTED";

export const INTERVIEW_STATUS_LABELS: Record<string, string> = {
  SCHEDULED: "予定済み",
  INTERVIEWED: "実施済み",
  COMPLETED: "完了",
  SUMMARY_CHECK_PENDING: "要約チェック待ち",
  SUMMARY_CHECK_COMPLETED: "要約チェック完了",
  CANCELLED: "キャンセル済み",
  [STAKEHOLDER_ANSWERS_IMPORTED]: "回答取り込み済み",
};

export const INTERVIEW_STATUS_CLASSES: Record<string, string> = {
  SCHEDULED: "bg-[#f3f4f6] text-[#4b5563]",
  INTERVIEWED: "bg-[#dbeafe] text-[#1e40af]",
  COMPLETED: "bg-[#dbeafe] text-[#1e40af]",
  SUMMARY_CHECK_PENDING: "bg-[#fef3c7] text-[#92400e]",
  SUMMARY_CHECK_COMPLETED: "bg-[#dcfce7] text-[#166534]",
  CANCELLED: "bg-[#fee2e2] text-[#991b1b]",
  [STAKEHOLDER_ANSWERS_IMPORTED]: "bg-[#dcfce7] text-[#166534]",
};

export const INTERVIEW_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "すべて" },
  { value: "SCHEDULED", label: "予定済み" },
  { value: "INTERVIEWED", label: "実施済み" },
  { value: "COMPLETED", label: "完了" },
  { value: "SUMMARY_CHECK_PENDING", label: "要約チェック待ち" },
  { value: "SUMMARY_CHECK_COMPLETED", label: "要約チェック完了" },
  { value: STAKEHOLDER_ANSWERS_IMPORTED, label: "回答取り込み済み" },
  { value: "CANCELLED", label: "キャンセル済み" },
];

// 実施済み以降＝要約チェックへ遷移できるステータス
export const SUMMARY_CHECKABLE_STATUSES: readonly string[] = [
  "INTERVIEWED",
  "COMPLETED",
  "SUMMARY_CHECK_PENDING",
  "SUMMARY_CHECK_COMPLETED",
];

interface InterviewDisplayStatusSource {
  status: string;
  zoomRecordingViewUrl?: string | null;
  stakeholderContext: { answersImported: boolean } | null;
}

/**
 * 画面に出すステータスを決める。
 *
 * ステークホルダーは AI 要約を作らないため要約チェックの状態遷移に乗らず、DB のステータスは
 * 予約したときのまま止まる。業務上の終わりは要約シートからの回答取り込みなので、表示だけ
 * そちらに合わせて導き直す。
 */
export function resolveInterviewDisplayStatus(
  interview: InterviewDisplayStatusSource,
): string {
  const { stakeholderContext } = interview;
  if (!stakeholderContext) {
    return interview.status;
  }
  if (interview.status === "CANCELLED") {
    return "CANCELLED";
  }
  if (stakeholderContext.answersImported) {
    return STAKEHOLDER_ANSWERS_IMPORTED;
  }
  // 録画が届いていれば実施は済んでいる。実施報告から実施済みになる経路も拾う
  if (interview.zoomRecordingViewUrl || interview.status !== "SCHEDULED") {
    return "INTERVIEWED";
  }
  return "SCHEDULED";
}
